import React from 'react';
import classNames from 'classnames';
import './Avatar.scss';
import FontAwesomeIcon from '../Icon';

const Avatar = ({ badge, size, url }: any) => (
  <div
    className={classNames('avatar', {
      [`avatar--${size}`]: size,
    })}
  >
    {badge &&
      ['property-manager', 'service-provider', 'home-owner'].indexOf(badge) >
        -1 && (
        <div className={classNames('avatar__badge', `avatar__badge--${badge}`)}>
          <FontAwesomeIcon
            size="tiny"
            weight="solid"
            glyph={
              badge === 'property-manager'
                ? 'shield-alt'
                : badge === 'service-provider'
                  ? 'wrench'
                  : badge === 'home-owner'
                    ? 'home'
                    : null
            }
          />
        </div>
      )}
    {badge === 'count' ? (
      <div className={classNames('avatar__badge', `avatar__badge--${badge}`)}>
        <FontAwesomeIcon
          size="tiny"
          weight="solid"
          glyph={badge === 'count' ? 'ellipsis-h' : null}
        />
      </div>
    ) : null}
    <img
      src={url || '/assets/avatar.svg'}
      className="avatar__image"
      alt="avatar"
    />
  </div>
);

export default Avatar;
